function setActivePairedFeatureItem(block, index) {
	const titles = block.querySelectorAll('.req-paired-feature-list-block__title');
	const panels = block.querySelectorAll('.req-paired-feature-list-block__image-wrapper');

	titles.forEach((title, itemIndex) => {
		title.classList.toggle('is-active', itemIndex === index);
	});

	panels.forEach((panel, itemIndex) => {
		panel.classList.toggle('is-active', itemIndex === index);
	});
}

function getDefaultActiveItemIndex(block) {
	const titleItems = Array.from(
		block.querySelectorAll('.req-paired-feature-list-block__title-item')
	);

	return titleItems.findIndex(
		(item) => item.getAttribute('data-display-state') === 'active'
	);
}

document
	.querySelectorAll('.wp-block-gfd-paired-feature-list-block')
	.forEach((block) => {
		const titles = block.querySelectorAll('.req-paired-feature-list-block__title');
		const titleItems = block.querySelectorAll(
			'.req-paired-feature-list-block__title-item'
		);
		const defaultActiveItemIndex = getDefaultActiveItemIndex(block);

		if (titles.length) {
			setActivePairedFeatureItem(
				block,
				defaultActiveItemIndex >= 0 ? defaultActiveItemIndex : 0
			);
		}

		titles.forEach((title, index) => {
			title.addEventListener('mouseenter', () => {
				if (defaultActiveItemIndex >= 0) {
					const defaultActiveItem = titleItems[defaultActiveItemIndex];
					const suppressActiveOnSiblingHover =
						defaultActiveItem?.getAttribute(
							'data-suppress-active-on-sibling-hover'
						) === 'true';

					if (!suppressActiveOnSiblingHover && index !== defaultActiveItemIndex) {
						return;
					}
				}

				setActivePairedFeatureItem(block, index);
			});
		});

		block.addEventListener('mouseleave', () => {
			if (defaultActiveItemIndex < 0) {
				return;
			}

			const defaultActiveItem = titleItems[defaultActiveItemIndex];
			const suppressActiveOnSiblingHover =
				defaultActiveItem?.getAttribute(
					'data-suppress-active-on-sibling-hover'
				) === 'true';
			const neverReturnToActiveAfterSiblingHover =
				defaultActiveItem?.getAttribute(
					'data-never-return-to-active-after-sibling-hover'
				) === 'true';

			if (
				suppressActiveOnSiblingHover &&
				!neverReturnToActiveAfterSiblingHover
			) {
				setActivePairedFeatureItem(block, defaultActiveItemIndex);
			}
		});
	});
